// Core imports
import * as React from 'react';
import jwt_decode from 'jwt-decode';
import { enableScroll, disableScroll } from 'src/utils/documentInteraction';
import InvoiceService from 'src/services/invoice';
import { downloadFile } from 'src/utils/downloadHelper';
import LocaleFormating from 'src/translation/localeFormating';

// Components imports
import MobileInvoiceCard from '../components/MobileInvoiceCard';
import SlideMenu from 'src/components/common/SlideMenu';
import EmptyInvoices from '../components/EmptyInvoices';
import InvoiceToolbar from '../components/InvoiceToolbar';
import InvoiceMobileFilters from '../components/InvoiceMobileFilters';
import Button from 'src/components/common/Button';
import ArSummaryMobile from 'src/components/AR-Summary/Mobile';

// Models imports
import InvoiceModel from 'src/model/invoice.model';
import { PaymentMobile } from '../components/PaymentMode/';

// Style and misc imports
import './InvoicesMobile.scss';
import Loader from 'src/components/common/Loader';
import ModalPaymentStatusMobile from '../components/ModalPaymentStatusMobile';
import { env } from 'src/shared/env';
import i18n from 'src/translation/i18n';
import TablePaginator from 'src/components/common/TablePagination';

class InvoicesMobile extends React.Component<
  IInvoicesMobileProps,
  IInvoicesMobileState
> {
  constructor(props: IInvoicesMobileProps) {
    super(props);

    this.state = {
      filtersMenuIsOpen: false,
      paymentMode: false
    };
  }

  private prepareInvoicesNumbers(): string[] {
    const invoicesNumber: any[] = [];
    this.props.selectedInvoices.map(invoice => {
      const isExist = invoicesNumber.filter(
        a => a.invoiceNo === invoice.invoiceNumber.toString()
      );
      if (isExist.length === 0) {
        invoicesNumber.push({
          invoiceNo: invoice.invoiceNumber.toString(),
          invoiceDate: invoice.invoiceDate.toString()
        });
      }
    });
    return invoicesNumber;
  }

  /* 
    downloadInvoices
   */
  private downloadInvoices = () => {
    const { selectedInvoices } = this.props;
    const selectedList = this.prepareInvoicesNumbers();
    if (selectedInvoices.length !== 0) {
      InvoiceService.downloadInvoices(selectedList).then((response: any) => {
        if (selectedInvoices.length === 1 || selectedList.length === 1) {
          downloadFile(
            response.data,
            `invoice-${
              selectedInvoices[0].invoiceNumber
            }-${LocaleFormating.getNowDate('short')}.pdf`
          );
        } else {
          downloadFile(
            response.data,
            `invoices${LocaleFormating.getNowDate('short')}.zip`
          );
        }
      });
    }
  };

  /* 
    openFiltersMenu
   */
  private openFiltersMenu = () => {
    this.setState({ filtersMenuIsOpen: true });
    window.scrollTo(0, 0);
    disableScroll();
  };

  /* 
    closeFiltersMenu
   */
  private closeFiltersMenu = () => {
    this.setState({ filtersMenuIsOpen: false });
    enableScroll();
  };

  /* 
    changeToPaymentMode
   */
  private changeToPaymentMode = () => {
    this.setState({ paymentMode: true });
    window.scrollTo(0, 0);
    disableScroll();
  };

  /* 
    closePaymentMode
   */
  private closePaymentMode = () => {
    this.setState({ paymentMode: false });
    this.props.clearAlert();
    enableScroll();
  };

  /* 
    getPayInvoiceStatus
   */
  private getPayInvoiceStatus = (): boolean => {
    return this.props.selectedInvoices.some(
      invoice => invoice.remainingAmount === 0 || invoice.status === 'PENDING'
    );
  };

  private hasPositiveInvoices = (): boolean => {
    return this.props.selectedInvoices.some(
      invoice => invoice.remainingAmount > 0
    );
  };

  /* 
    getInvoiceCards
   */
  private getInvoiceCards = (): JSX.Element[] => {
    const cards: JSX.Element[] = [];

    if (this.props.getInvoicesIsPending) {
      cards.push(
        <div className="rp-invoices-mobile--empty" key={'loadingInvoices'}>
          <EmptyInvoices type="loading" />
        </div>
      );
    } else if (this.props.invoiceContent.length === 0) {
      cards.push(
        <div className="rp-invoices-mobile--empty" key={'noResultsInvoices'}>
          <EmptyInvoices type="noResults" />
        </div>
      );
    } else {
      this.props.invoiceContent.map((invoice, index) => {
        const isSelected = this.props.isInvActive.indexOf(invoice.idx) !== -1;
        cards.push(
          <MobileInvoiceCard
            key={`${index}`}
            invoice={invoice}
            onInvoiceSelect={this.props.setSelectedInvoices}
            isSelected={isSelected}
          />
        );
      });
    }

    return cards;
  };

  /* 
    userStatusCheck
   */
  private userStatusCheck = () => {
    const userStatus = {
      isLoggedIn: false,
      accountId: 'empty',
      sub: 'noAccount'
    };
    userStatus.isLoggedIn = 'accessToken' in localStorage;
    if (userStatus.isLoggedIn) {
      const token = jwt_decode(localStorage.getItem('accessToken'));
      userStatus.accountId = token.accountId;
      userStatus.sub = token.sub;
    }
    return userStatus;
  };

  public render() {
    const { t, selectedInvoices } = this.props;
    const userStatus = this.userStatusCheck();
    const invoicesStatus = this.getPayInvoiceStatus();
    const hasPositiveInvoices = this.hasPositiveInvoices();
    const language = i18n.language.split('-')[0];

    return (
      <React.Fragment>
        <SlideMenu
          mounted={this.state.filtersMenuIsOpen}
          level={11 + 30}
          goBackTitle={t('common.backToResults')}
          handleCloseMenu={() => {
            this.closeFiltersMenu();
          }}
        >
          <InvoiceMobileFilters closeFilterMenu={this.closeFiltersMenu} />
        </SlideMenu>
        <SlideMenu
          goBackTitle={t('common.back')}
          mounted={this.state.paymentMode}
          handleCloseMenu={this.closePaymentMode}
          level={11 + 30}
        >
          <PaymentMobile
            handleCloseMenu={this.closePaymentMode}
            selectedInvoices={this.props.selectedInvoices}
            userAccount={userStatus.accountId}
          />
        </SlideMenu>
        <div className="rp-invoices-mobile">
          {!this.props.isPendingPayment && this.props.showStatusModal ? (
            <ModalPaymentStatusMobile
              authorized={this.props.authorized}
              trackingNumber={this.props.trackingNumber}
              errorMessage={this.props.errorMessage}
              closeStatusModal={this.props.closeStatusModal}
            />
          ) : (
            <React.Fragment>
              <div className="rp-invoices-ar-summary-container--mobile">
                <ArSummaryMobile renderType={'other'} />
              </div>
              <div className="rp-invoices-mobile--filters-and-pay">
                <div
                  className="filters-and-pay--open-filters"
                  onClick={this.openFiltersMenu}
                >
                  <i className="rpds-sort" />
                  <span className="filters-text">
                    {t('common.filtersAndSorting')}
                  </span>
                </div>
                {env.REACT_APP_BASE_ENVIRONMENT === 'CA' ? (
                  <div className="rp-invoice-filterbar-mobile-eft-download">
                    <a
                      target="_blank"
                      href={
                        language === 'fr'
                          ? `${env.REACT_APP_BASE_WORDPRESS_URL}wp-content/rpfiles/Reliable_Parts_Canada_Electronic_Payment_Information_French.pdf`
                          : `${env.REACT_APP_BASE_WORDPRESS_URL}wp-content/rpfiles/Reliable_Parts_Canada_Electronic_Payment_Information.pdf`
                      }
                    >
                      {t('accountMonthlyStatements.makeYourPaymentsViaLink')}
                    </a>
                  </div>
                ) : (
                  ''
                )}
                <Button
                  buttonClass="primary-custom-button"
                  label={t('invoices.payInvoicesCredits')}
                  textTransform="uppercase"
                  disabled={
                    invoicesStatus ||
                    this.props.selectedInvoices.length <= 0 ||
                    this.props.isPendingPayment ||
                    !hasPositiveInvoices ||
                    this.props.selectedInvoices.some(
                      invoice =>
                        invoice.status === 'PAID' &&
                        invoice.description !== 'Credit Note'
                    )
                  }
                  height="48px"
                  action={() => {
                    if (selectedInvoices.length !== 0) {
                      this.changeToPaymentMode();
                    }
                  }}
                />
                {invoicesStatus && (
                  <span className="rp-pay-invoices--block-payment">
                    {t('invoices.zeroAmountInvoice')}
                  </span>
                )}
              </div>
              <TablePaginator
                handlePagination={this.props.handlePagination}
                pagination={this.props.pagination}
              />
              <InvoiceToolbar
                onClearClicked={this.props.clearSelectedInvoices}
                selectedInvoices={this.props.selectedInvoices}
                removeInvoiceFromSelected={this.props.removeInvoiceFromSelected}
                onDownloadClicked={() => {
                  this.downloadInvoices();
                }}
              />
              <div className="rp-invoice-mobile--cards-container">
                {this.getInvoiceCards()}
              </div>
              {this.props.isPendingPayment ? <Loader /> : null}
            </React.Fragment>
          )}
        </div>
      </React.Fragment>
    );
  }
}

export default InvoicesMobile;

interface IInvoicesMobileProps {
  setSelectedInvoices(invoices: InvoiceModel | InvoiceModel[]): void;
  clearSelectedInvoices(): void;
  removeInvoiceFromSelected(invoice: InvoiceModel): void;
  t: any;
  getInvoicesIsPending: boolean;
  invoiceContent: InvoiceModel[];
  selectedInvoices: InvoiceModel[];
  isInvActive: string[];
  authorized: boolean;
  trackingNumber: string;
  errorMessage: string;
  isPendingPayment: boolean;
  showStatusModal: boolean;
  creditCardSuccess: any;
  successPayment: any;
  closeStatusModal: () => void;
  clearAlert: () => void;
  handlePagination: (type: any) => void;
  pagination: {
    pageNumber: number;
    pageSize: number;
    totalPages: number;
  };
}

interface IInvoicesMobileState {
  filtersMenuIsOpen: boolean;
  paymentMode: boolean;
}
